import { useAuthenticator } from '@aws-amplify/ui-react';
import { Box, Button, Typography } from '@mui/material';
import { signOut } from 'aws-amplify/auth';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { MobiTitle } from '@/components/shared/MobiTitle';
import { useServiceType } from '@/modules/hooks/useServiceType';
import * as paths from '@/routes/paths';
import { settingState } from '@/state/settingState';
import { ServiceType } from '@/types/serviceType';

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const [, setSetting] = useRecoilState(settingState);
  const serviceType = useServiceType();

  const logout = useCallback(() => {
    signOut()
      .then(() => {
        setSetting(undefined);
        navigate(paths.login);
      })
      .catch(() => {});
  }, [navigate, setSetting]);

  const goBack = () => {
    if (['authenticated', 'configuring'].includes(authStatus) && serviceType) {
      if (serviceType === ServiceType.FixedRouteSchedule || serviceType === ServiceType.RealtimeOnDemand) {
        navigate(paths.vehicleDriverSelect);
      } else if (serviceType === ServiceType.PreBooking) {
        navigate(paths.driveList);
      }
    } else {
      logout();
    }
  };

  useEffect(() => {
    if (authStatus === 'unauthenticated') {
      navigate(paths.login);
    }
  }, [navigate, authStatus]);

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" flex={1} height="100%">
      <MobiTitle>404</MobiTitle>
      <Typography variant="h6" mb={2}>
        {t('error.notFoundPage')}
      </Typography>
      <Button variant="contained" onClick={goBack}>
        {t('error.back')}
      </Button>
    </Box>
  );
};
